<template>
  <div class="regimen-checker modal-container">
    <div class="modal-wrapper">
      <div class="modal-content">
        <review-step
          v-if="step === 'review'"
          @nextStep="goToRegimen"/>
        <regimen-step
          v-if="step === 'regimen'"
          @nextStep="goToPackage"/>
        <package-step
          v-if="step === 'package'"
          @prevStep="goToRegimen"
          @nextStep="goToSubscribeForm"/>
        <subscribe-form
          v-if="step === 'subscribeForm'"
          :plan = "currentPlan"
          @prevStep="goToPackage"/>
        <span 
          class="close-modal" 
          @click.prevent="showModal(false)">+</span>
      </div>
    </div>
  </div>
</template>
<script>
import ReviewStep from "./steps/ReviewStep";
import RegimenStep from "./steps/RegimenStep";
import PackageStep from "./steps/PackageStep";
import SubscribeForm from "./steps/SubscribeForm";
import profileMixin from "@/mixins/profileMixin";

export default {

    components: {
        SubscribeForm,
        PackageStep,
        RegimenStep,
        ReviewStep
    },
    mixins: [profileMixin],

    data: () => ({
        step: 'review',
        currentPlan: null
    }),

    methods: {

        goToRegimen() {
            this.step = 'regimen';
        },

        goToPackage() {
            this.step = 'package';
        },

        goToSubscribeForm(plan) {
            this.currentPlan = plan;
            this.step = 'subscribeForm';
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/modals/RegimenChecker/RegimenCheckerModal.vue